import axios, { AxiosRequestConfig } from 'axios';

const axiosConfig: AxiosRequestConfig = {
  baseURL: `${process.env.REACT_APP_HEJHOME_API_URL}`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
  },
};

export const instance = axios.create(axiosConfig);
